/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import FormsView from './FormsView';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/forms'),
    name: 'forms_home',
    component: FormsView,
    roles: ['administrator', 'agent'],
    props: route => {
      return { accountId: route.params.accountId };
    },
  },
];
